import { render, staticRenderFns } from "./CashmereLongImage.vue?vue&type=template&id=248a6982&scoped=true"
import script from "./CashmereLongImage.vue?vue&type=script&lang=js"
export * from "./CashmereLongImage.vue?vue&type=script&lang=js"
import style0 from "./CashmereLongImage.vue?vue&type=style&index=0&id=248a6982&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248a6982",
  null
  
)

export default component.exports